import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Container } from "./Primitives";
import { VideoBand } from "./VideoBand";
import { Ornament } from "./Ornament";
import { Reveal } from "../lib/motion";

const CHIPS = ["₹499, credited back", "A named consultant", "No obligation"];

export function FinalCTA() {
  return (
    <VideoBand
      src="/video/cta-gold-peacock.mp4"
      webm="/video/cta-gold-peacock.webm"
      poster="/video/cta-gold-peacock-poster.jpg"
      scrim={0.66}
      rate={0.6}
      surround="#ffffff"
      testId="final-cta"
      className="border-t border-rule"
    >
      <Container className="py-[110px] text-center max-md:py-[70px]">
        <Reveal>
          <Ornament className="mb-7" />
          <p className="eyebrow-wide">Start with a question, not a purchase</p>
          <h2 className="section-title mx-auto mt-6 max-w-3xl !text-[#f3efe7]">
            Not sure you need a stone at all? <span className="italic">Good — ask us that.</span>
          </h2>
          <p className="hero-desc ui mx-auto mt-6 text-[#f3efe7]/85">
            Twenty minutes with a named consultant who earns nothing from what you buy. If the honest
            answer is that you need nothing, that is what you will be told — and we publish how often
            that happens.
          </p>

          <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
            {CHIPS.map((c) => (
              <span
                key={c}
                className="ui inline-flex items-center gap-1.5 border border-[#f3efe7]/30 px-3.5 py-2 text-[11px] uppercase tracking-[0.1em] text-[#f3efe7]/85"
                data-testid={`cta-chip-${c.split(" ")[0].toLowerCase()}`}
              >
                <Check className="h-3 w-3 text-[#7fd0a8]" aria-hidden="true" />
                {c}
              </span>
            ))}
          </div>

          <Link
            to="/consult/suitability-session"
            className="btn btn-primary btn-cta mt-9"
            data-testid="final-cta-button"
          >
            Start with the ₹499 session — credited back when you buy
          </Link>
        </Reveal>
      </Container>
    </VideoBand>
  );
}
